<template>
  <div v-loading="loading" element-loading-text="拼命加载中">
    <div class="info-box">
      <div class="title-box">
        <p>我的基础信息</p>
      </div>
      <div class="info-content">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="14">
                <div class="user-profile-name">{{info.name}}</div>
                <div class="custom-tab user-profile-tab">
                  <ul class="nav nav-tabs"></ul>
                  <div class="tab-content">
                    <div class="tab-pane active">
                      <div class="contact-information">
                        <div class="phone-content">
                          <span class="contact-title">志愿者编号:</span>
                          <span class="phone-number">{{info.number}}</span>
                        </div>
                        <div class="phone-content">
                          <span class="contact-title">志愿者身份:</span>
                          <span class="phone-number">{{info.identity_type_text}}</span>
                        </div>
                        <div class="phone-content" v-if="info.identity_type==1">
                          <span class="contact-title">顺丰工号：</span>
                          <span class="phone-number">{{info.job_no}}</span>
                        </div>
                        <div class="phone-content">
                          <span class="contact-title">手机号码:</span>
                          <span class="phone-number">{{info.mobile}}</span>
                        </div>
                        <div class="email-content">
                          <span class="contact-title">Email:</span>
                          <span class="contact-email">{{info.email}}</span>
                        </div>
                        <div class="address-content">
                          <span class="contact-title">{{info.card_no_type_text}}：</span>
                          <span class="mail-address">{{info.card_no}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <img
                    :src="item.medal_picture_text[0].path"
                    :title="item.medal_name"
                    style="max-width: 50px;padding:20px;"
                    v-for="(item,index) in info.volunteer_medal_list"
                    :key="index"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>

    <div class="c-bottom">
      <div class="public-box">
        <div class="public-title">
          <p>活动足迹</p>
        </div>
        <div class="train-box">
          <div class="train-top">
            <WtDataList
              v-model="activityApplyList"
              :url="$url.activity.apply.user"
              :pageSize="3"
              ref="activityRef"
            >
              <div slot="list">
                <ul class="activity_ul">
                  <li v-for="(item,index) in activityApplyList" :key="index">
                    <div class="left-box">
                      <h5>{{getDate(item.created_at,'MD')}}</h5>
                      <p>{{getDate(item.created_at,'Y')}}</p>
                    </div>
                    <div class="right-box">
                      <h5>{{item.activity_name}}</h5>
                      <p>活动地点：{{item.province_text+item.city_text+item.country_text}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </WtDataList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activityApplyList: [],
      loading: true,
      info: {},
      navStatus: 1,
      navList: [
        {
          id: 1,
          name: "首页",
          icon: "icon-shouye"
        },
        {
          id: 2,
          name: "基本信息",
          icon: "icon-wode"
        },
        {
          id: 3,
          name: "培训足迹",
          icon: "icon-wodezuji"
        },
        {
          id: 4,
          name: "学期总结",
          icon: "icon-wenzhang"
        },
        {
          id: 5,
          name: "项目培训",
          icon: "icon-fenlei"
        }
      ],
      trainList: [
        {
          id: 1,
          title: "2019级项目成员岗前培训成长",
          content:
            "感谢各大高校社团及义工对为中国而教校园招募宣讲会的鼎力支持。"
        },
        {
          id: 1,
          title: "2018级项目成员岗前培训成长",
          content:
            "因为你们，我们多了一份继续前行的力量！ 感谢对中国教育公平与公益事业的支持！"
        },
        {
          id: 1,
          title: "2017级项目成员岗前培训成长",
          content:
            "感谢各大高校社团及义工对为中国而教校园招募宣讲会的鼎力支持。"
        }
      ],
      termList: [
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        },
        {
          id: 1,
          name: "2018-2019年度学期总结"
        }
      ]
    };
  },
  methods: {
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    getDate(date, format = "M") {
      switch (format) {
        case "Y": {
          return date.substring(0, 4);
          break;
        }
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
        default: {
          return date.substring(5, 10);
          break;
        }
      }
    }
  },
  mounted() {
    this.$db.get(this.$url.volunteer.url).then(resp => {
      this.info = resp.data;
      console.log(resp, "resp");
      this.loading = false;
    });
  }
};
</script>


<style lang="scss" scoped>
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .list-box {
      height: 19.518518518518517vh;
      width: 10.416666666666667vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      .list-time {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        overflow: hidden;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          text-align: center;
          margin-top: 4.814814814814815vh;
          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > i {
          display: block;
          width: 100%;
          font-style: normal;
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          // margin-top: 0.7259259259259259vh;
          text-align: center;
        }
      }
      .list-top {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          line-height: 13.796296296296295vh;
          text-align: center;

          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 13.796296296296295vh;
          text-align: center;
        }
      }
      .list-bottom {
        height: 4.6296296296296294vh;
        position: relative;
        > p {
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          line-height: 1.4814814814814815vh;
          padding-left: 0.7291666666666667vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1caee0;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
.c-bottom {
  display: flex;
  justify-content: space-between;
  .public-box {
    //width: 38.54166666666667vw;
    width: 100%;
    padding-bottom: 6.066666666666667vh;
    .public-title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      > p {
        color: #414c60;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
      > h5 {
        font-weight: normal;
        color: #8d95a4;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
    }
    .train-box {
      width: 100%;
      //height: 44.44444444444444vh;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      margin-top: 1.6666666666666666vh;
      border: solid 1px #e6e7eb;
      overflow: hidden;
      .train-top {
        width: 100%;
        //height: 34.16666666666667vh;
      }
      .term-box {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          li {
            list-style: none;
            display: flex;
            margin-bottom: 5vh;
            &:last-child {
              margin-bottom: 0;
            }
            > p {
              width: 4.0625vw;
              height: 2.3148148148148147vh;
              border-right: 1px solid #e4e5e9;
              font-size: 2.2222222222222223vh;
              line-height: 2.3148148148148147vh;
              color: #bfc0c8;
            }
            .score-box {
              width: 29.635416666666664vw;
              display: flex;
              justify-content: space-between;
              padding-left: 1.3020833333333334vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 2.3148148148148147vh;
              }
              > p {
                > span {
                  font-size: 2.3666666666666666vh;
                  line-height: 2.3148148148148147vh;
                  color: #414c60;
                }
              }
            }
          }
        }
      }
      .train-bottom {
        height: 10.092592592592593vh;
        background-color: #1caee0;
        position: relative;
        > p {
          font-size: 2.2222222222222223vh;
          color: #fff;
          font-weight: 600;
          padding-left: 3.4895833333333334vw;
          line-height: 4.6296296296296294vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #1caee0;
            font-size: 4.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
          > i {
            font-style: normal;
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #feb64d;
            font-size: 2.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
        }
      }
    }
  }
}
.activity_ul {
  padding: 4.6296296296296294vh 2.1875vw;
  > li {
    list-style: none;
    display: flex;
    margin-bottom: 5.3703703703703705vh;
    &:last-child {
      margin-bottom: 0;
    }
    .left-box {
      height: 4.4444444444444446vh;
      width: 5vw;
      border-right: 1px solid #e4e5e9;
      > h5 {
        font-weight: normal;
        color: #bfc0c8;
        font-size: 24px;
        line-height: 2.7777777777777776vh;
      }
      > p {
        font-size: 16px;
        color: #bfc0c8;
      }
    }
    .right-box {
      padding-left: 1.5625vw;
      //width: 26.666666666666666vw;
      > h5 {
        color: #414c60;
        font-size: 16px;
        line-height: 20px;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
        margin-bottom: 1.0037037037037037vh;
      }
      > p {
        color: #8d95a4;
        font-size: 14px;
        // line-height: 1.2962962962962963vh;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
    }
  }
}
</style>

<style scoped>
.user-profile-name {
  display: inline-block;
  font-size: 22px;
  font-weight: 500;
  padding: 0px 15px;
}
.user-profile-tab {
  margin-top: 15px;
  padding: 0px 15px;
}
.nav-tabs {
  /*border-bottom: 1px solid #dee2e6;*/
}
.contact-information,
.basic-information {
  margin: 10px 0px;
}
.contact-title {
  display: inline-block;
  padding-bottom: 15px;
  width: 170px;
  font-size: 16px;
  color: #868e96;
}
.phone-number,
.mail-address,
.contact-email,
.contact-website,
.contact-skype,
.birth-date,
.gender {
  font-size: 16px;
  color: #373757;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/user/index.vue